import { render } from "./GenericExercisePrice.vue?vue&type=template&id=6d40e8e4"
import script from "./GenericExercisePrice.vue?vue&type=script&lang=ts"
export * from "./GenericExercisePrice.vue?vue&type=script&lang=ts"
script.render = render

export default script